import type { ValidationError } from '@openx/types/api.ts';
import type { HTTPError } from 'ky';
import { type ApiFieldValidationErrors, apiValidationErrors } from './apiValidationErrors.ts';
import { type FieldsLabelsConfig, fieldsLabels } from './fieldsLabels.ts';

export interface ValidationErrors<T> {
  fieldsErrors: ApiFieldValidationErrors<T>;
  formErrors: string[];
}

export function getValidationErrors<T>(
  labelsMap: FieldsLabelsConfig<Partial<T>>,
  apiErrorObject?: Error | ValidationError<T> | HTTPError | null
): ValidationErrors<T> {
  const apiValidationErrorsObject = apiValidationErrors<T>(apiErrorObject);
  const fieldsLabelsObject = fieldsLabels<Partial<T>>(labelsMap);

  const fieldsErrors = apiValidationErrorsObject.getFieldErrors().map(fieldError => ({
    ...fieldError,
    error: fieldsLabelsObject.insertLabel(fieldError.error, fieldError.fieldId),
  }));

  const formErrors = fieldsErrors
    ? fieldsErrors.map(fieldError => fieldError.error)
    : apiValidationErrorsObject.getOtherErrors();

  return {
    fieldsErrors,
    formErrors,
  };
}
